import { Modal } from "@cloud/atom-ui";
import { i18n, locale } from "@src/utils/i18n";
import webConfig from "@src/configs/web.config";
import * as nls from "@src/nls";

const I18N = i18n(nls);
// 对之前的fetch进行备份到另一个变量中
let oldFetch = global.fetch;
if (typeof window !== "undefined" && typeof self !== "undefined") {
  oldFetch = self.fetch;
}
if (global) {
  oldFetch = global.fetch;
}

// 新的retch
let newFetch = function (url, options = {}) {
  let request = {
    url,
    options
  };
  return new Promise((resolve, reject) => {
    if (this.interceptors.length > 0) {
      //执行请求前的拦截操作
      this.runInterceptors(0, request).then(req => {
        oldFetchFun(this, req)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      oldFetchFun(this, request)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    }
  });
};

// 是否是数组
function isArray(val) {
  return Array.isArray(val);
}

// 是否是对象
function isNormalObject(val) {
  return typeof val === "object";
}

// body是对象就进行JSON转化后返回json字符串
function transformRequest(body) {
  try {

    if (body && (isNormalObject(body) || isArray(body))
      && !(body instanceof FormData)) {
      return JSON.stringify(body);
    }
  } catch (e) {
    console.log(' transformRequest e', e);
  }
  return body;
}

// url上加上时间戳和语言
const addParamToUrl = function (request) {
  if (!request.options?.method || request.options?.method === "GET" || request.options?.method === "get") {
    if (request?.url?.indexOf("?") > 0) {
      request.url += `&_t=${+new Date()}`;
    } else {
      request.url += `?_t=${+new Date()}`;
    }
  }

  if (!request.options?.params?.language) {
    let lang = locale === "en" ? "en" : "zh";
    if (request.url.indexOf("?") > 0) {
      request.url += `&language=${lang}`;
    } else {
      request.url += `?language=${lang}`;
    }
  }
};

// header中增加 content-type 和 token
const addParamToHeader = function (request) {
  if (!request?.options["headers"]) {
    request.options = {
      ...request.options,
      headers: {}
    };
  }

  let body = request?.options?.body;
  if ((typeof body === "string" || isNormalObject(body) || isArray(body))
    && !(body instanceof FormData)) {
    let header = {
      "Content-Type": "application/json;charset=utf-8"
    };
    request.options["headers"] = {
      ...header,
      ...request.options["headers"]
    };
  }

  const token = window.document.cookie.match(/X-XSRF-TOKEN=([^;]+)?/);
  if (token) {
    request.options["headers"] = {
      ...request.options["headers"],
      ...{
        "X-XSRF-TOKEN": token[1]
      }
    };
  }
};

// 数据转化
const processData = (responseType, res) => {
  if (res.url.search(/\.js$/) >= 0 || res.url.search(/%3Canonymous%3E/) >= 0) {
    return res;
  }
  switch (responseType) {
    case "json": {
      return res.json();
    }
    case "blob": {
      return res.blob();
    }
    case "text": {
      return res.text();
    }
    case "arrayBuffer": {
      return res.arrayBuffer();
    }
    case "formData": {
      return res.formData();
    }
    default: {
      return res.json();
    }
  }
};

const clearReqTimeout = (timer) => {
  if (timer) {
    timer = null;
    clearTimeout(timer);
  }
}

// 解析返回的数据
const paraData = (resPromise, isError, resolve, reject) => {
  resPromise.then(
    res => {
      // status 505 未认证, 跳转到认证界面
      if (res?.status === 505) {
        let lang = locale === "en" ? "en" : "zh";
        if (webConfig.isRedBlue) {
          openLogin();
        } else {
          window.location.href = `${window.location.protocol}/#/wecode/certify?redirect_uri=${encodeURIComponent(window.location.href)}&language=${lang}`
        }
        return true
      }
      if (isError) {
        reject(res);
      } else {
        resolve(res);
      }
    },
    error => {
      reject(error);
    }
  ).catch(error => {
    reject(error);
  });
}

// 进行网络请求
let oldFetchFun = function (that, request) {
  return new Promise((resolve, reject) => {
    //添加超时检测
    let timeout = request.options?.timeout;
    let timer;
    if (timeout) {
      timer = setTimeout(function () {
        reject(new Error("fetch timeout"));
      }, timeout);
    }
    addParamToUrl(request);
    addParamToHeader(request);
    if (request.options?.body) {
      request.options.body = transformRequest(request.options?.body);
    }
    let isError = "";
    let resPromise = oldFetch(request.url, request.options)
      .then(res => {
        clearReqTimeout(timer);
        if (isErrorProcess(res)) {
          isError = true;
          return res.text();
        }
        let responseType = request.options.responseType;
        const data = processData(responseType, res);
        return data;
      }, (error) => {
        handleError(timer, error, reject);
      }).catch((error) => {
        handleError(timer, error, reject);
      });
    // 解析返回的数据
    paraData(resPromise, isError, resolve, reject);
  });
};

const handleError = (timer, error, reject) => {
  clearReqTimeout(timer);
  jumpToLogin(error)
  reject(error);
}

// 如果返回的是重定向就跳转到登录
function jumpToLogin(error) {
  if (error && error.stack && !(error.stack.search("TypeError") >= 0 || error.stack.search("SyntaxError") >= 0)) {
    openLogin();
  }
}

// 处理异常
function isErrorProcess(response) {
  // 401 重新登录
  if (response.status == 401) {
    openLogin();
    return true;
  }
  // 403 重新登录
  if (response.status == 403) {
    openLogin();
    return true;
  }
  // 500
  if (response.status == 500 || response.status == 404) {
    Modal.error({
      content: I18N["服务端接口异常，请与平台客服沟通"]
    });
    return true;
  }
  if (response.status == 400 || response.status == 502) {
    Modal.error({
      content: I18N["请求错误，请稍后再试"]
    });
    return true;
  }
  if (response.status == 504) {
    Modal.error({
      content: I18N["服务端接口连接超时，请检查您当前的网络状态"]
    });
    return true;
  }

  if (response.type === "opaqueredirect") {
    openLogin();
    return true;
  }
  return false;
}

let breadFetch = function () { };

breadFetch.prototype.newFetch = newFetch;

//fetch拦截器
breadFetch.prototype.interceptors = [];
breadFetch.prototype.interceptors_after = [];
breadFetch.prototype.runInterceptors = function (i, request) {
  let _that = this;
  if (i === 0) this.interceptors_after = [];
  return new Promise((resolve, reject) => {
    if (i >= this.interceptors.length) resolve(request);
    this.interceptors[i](request, function (callback) {
      if (callback) {
        //callback 存入请求后执行的数组
        _that.interceptors_after.push(callback);
      }
      _that.runInterceptors(++i, request).then(req => {
        resolve(req);
      });
    });
  });
};

let objFetch = new breadFetch();
let fetch = function (url, options = {}) {
  return new Promise((resolve, reject) => {
    objFetch
      .newFetch(url, options)
      .then(data => {
        //国际化 message处理
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

function openLogin() {
  window.location.href = webConfig.goLoginURl(window.location.href);
}

// 重新对fetch赋值
if (typeof window !== "undefined" && typeof self !== "undefined") {
  self.fetch = fetch;
}
if (global) {
  global.fetch = fetch;
}


export const hwFetch = (url, options = {}) => {
  let token = window.document.cookie.match(/hw_mobile=([^;]+)?/);
  const loginToken = window.document.cookie.match(/X-XSRF-TOKEN=([^;]+)?/);
  // 如果有登录的token   则直接用登录的
  if (loginToken) {
    token = loginToken
  }
  const mOptions = token ? {
    ...options,
    headers: {
      ...options['headers'],
      "hw_mobile": token[1]
    }
  } : { ...options };
  return fetch(url, mOptions);
}
